import { render, staticRenderFns } from "./EditorViewer.vue?vue&type=template&id=ec6bb646&"
import script from "./EditorViewer.vue?vue&type=script&lang=ts&"
export * from "./EditorViewer.vue?vue&type=script&lang=ts&"
import style0 from "./EditorViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports